import { ReactNode } from 'react';

interface FormLabelProps {
  children?: ReactNode;
  className?: string;
  htmlFor?: string;
}

const FormLabel = ({ children, className, htmlFor }: FormLabelProps) => {
  return (
    <label
      className={className}
      htmlFor={htmlFor}
    >
      {children}
    </label>
  );
};

export default FormLabel;
